import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row h-screen w-full overflow-hidden bg-white dark:bg-gray-950" }
const _hoisted_2 = { class: "w-full md:w-2/5 lg:w-3/5 h-48 md:h-full p-4 md:p-6" }
const _hoisted_3 = { class: "relative h-full w-full overflow-hidden rounded-lg bg-purple-50 dark:bg-gray-900" }
const _hoisted_4 = { class: "w-full md:w-3/5 lg:w-2/5 flex items-center justify-center p-8 md:p-12" }
const _hoisted_5 = { class: "w-full max-w-md space-y-8" }

type FormState = "login" | "forgot-password" | "otp";


export default /*@__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

definePageMeta({
  layout: "auth",
});

useHead({
  title: "FamilyAxis Login",
  meta: [{ name: "description", content: "FamilyAxis Login" }],
  bodyAttrs: {
    class: "FamilyAxis Login",
  },
});

const formState = ref<FormState>("login");
const emailForOtp = ref<string>("");

function handleForgotPassword() {
  formState.value = "forgot-password";
}

function handleBackToLogin() {
  formState.value = "login";
  emailForOtp.value = "";
}

function handleOtpSent(email: string) {
  emailForOtp.value = email;
  formState.value = "otp";
}

function handleBackToForgot() {
  formState.value = "forgot-password";
}

return (_ctx: any,_cache: any) => {
  const _component_UColorModeImage = _resolveComponent("UColorModeImage")!
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_ForgotPasswordForm = _resolveComponent("ForgotPasswordForm")!
  const _component_OtpForm = _resolveComponent("OtpForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute inset-0" }, [
          _createElementVNode("div", { class: "wave wave-1" }),
          _createElementVNode("div", { class: "wave wave-2" }),
          _createElementVNode("div", { class: "wave wave-3" })
        ], -1)),
        _createElementVNode("div", {
          class: "absolute top-6 left-1/2 -translate-x-1/2 md:left-6 md:translate-x-0 z-10 flex items-center gap-3 hover:cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo('/')))
        }, [
          _createVNode(_component_UColorModeImage, {
            light: "/images/logo_light.svg",
            dark: "/images/logo_dark.svg",
            class: "h-10 w-auto",
            alt: "FamilyAxis Logo"
          }),
          _createVNode(_component_UColorModeImage, {
            light: "/images/familyaxis.svg",
            dark: "/images/familyaxis_dark.svg",
            class: "h-6 w-auto",
            alt: "FamilyAxis Text"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_unref(formState) === 'login')
          ? (_openBlock(), _createBlock(_component_LoginForm, {
              key: 0,
              onForgotPassword: handleForgotPassword
            }))
          : (_unref(formState) === 'forgot-password')
            ? (_openBlock(), _createBlock(_component_ForgotPasswordForm, {
                key: 1,
                onOtpSent: handleOtpSent,
                onBackToLogin: handleBackToLogin
              }))
            : (_unref(formState) === 'otp')
              ? (_openBlock(), _createBlock(_component_OtpForm, {
                  key: 2,
                  email: _unref(emailForOtp),
                  onBackToForgot: handleBackToForgot
                }, null, 8, ["email"]))
              : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})